import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import SuitcaseIcon from '@atlaskit/icon/core/migration/briefcase--suitcase';
import EmojiFrequentIcon from '@atlaskit/icon/core/migration/clock--emoji-frequent';
import DepartmentIcon from '@atlaskit/icon/core/migration/department';
import EmailIcon from '@atlaskit/icon/core/migration/email';
import LocationIcon from '@atlaskit/icon/core/migration/location';
import { Inline } from '@atlaskit/primitives';
import Tooltip from '@atlaskit/tooltip';
import { messages } from '../../../../../messages';
import { ProfileSectionPrimaryUserAddtlIconPadding, ProfileSectionPrimaryUserInfo, ProfileSectionPrimaryUserInfoText } from './styled';
export var UserInfoTypeFormat = /*#__PURE__*/function (UserInfoTypeFormat) {
  UserInfoTypeFormat["JOBTITLE"] = "JOB_TITLE";
  UserInfoTypeFormat["DEPARTMENT"] = "DEPARTMENT";
  UserInfoTypeFormat["LOCATION"] = "LOCATION";
  UserInfoTypeFormat["TIME"] = "TIME";
  UserInfoTypeFormat["EMAIL"] = "EMAIL";
  return UserInfoTypeFormat;
}({});
var userInfoTypeMapper = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, UserInfoTypeFormat.JOBTITLE, {
  tooltipMessage: messages.ai_answer_who_questions_hover_role_icon,
  icon: /*#__PURE__*/React.createElement(SuitcaseIcon, {
    label: "",
    LEGACY_size: "small",
    color: "var(--ds-text-subtlest, #626F86)",
    testId: "primary-user-suitcase-icon"
  })
}), UserInfoTypeFormat.DEPARTMENT, {
  tooltipMessage: messages.ai_answer_who_questions_hover_department_icon,
  icon: /*#__PURE__*/React.createElement(DepartmentIcon, {
    label: "",
    LEGACY_size: "small",
    color: "var(--ds-text-subtlest, #626F86)",
    testId: "primary-user-department-icon"
  })
}), UserInfoTypeFormat.LOCATION, {
  tooltipMessage: messages.ai_answer_who_questions_hover_location_icon,
  icon: /*#__PURE__*/React.createElement(LocationIcon, {
    label: "",
    LEGACY_size: "small",
    color: "var(--ds-text-subtlest, #626F86)",
    testId: "primary-user-location-icon"
  })
}), UserInfoTypeFormat.TIME, {
  tooltipMessage: messages.ai_answer_who_questions_hover_local_time_icon,
  icon: /*#__PURE__*/React.createElement(EmojiFrequentIcon, {
    label: "",
    LEGACY_size: "small",
    color: "var(--ds-text-subtlest, #626F86)",
    testId: "primary-user-emoji-frequent-icon"
  })
}), UserInfoTypeFormat.EMAIL, {
  tooltipMessage: messages.ai_answer_who_questions_hover_email_icon,
  icon: /*#__PURE__*/React.createElement(EmailIcon, {
    label: "",
    LEGACY_size: "small",
    color: "var(--ds-text-subtlest, #626F86)",
    testId: "primary-user-email-icon"
  })
});
export var ProfileSectionUserInfo = function ProfileSectionUserInfo(_ref) {
  var userInfo = _ref.userInfo,
    userInfoType = _ref.userInfoType,
    applyAdditionalTopIconPadding = _ref.applyAdditionalTopIconPadding;
  return userInfo ? /*#__PURE__*/React.createElement(ProfileSectionPrimaryUserInfo, null, /*#__PURE__*/React.createElement(Inline, {
    space: "space.075",
    alignBlock: "center"
  }, /*#__PURE__*/React.createElement(Tooltip, {
    position: "top",
    content: /*#__PURE__*/React.createElement(FormattedMessage, userInfoTypeMapper[userInfoType].tooltipMessage)
  }, applyAdditionalTopIconPadding ? /*#__PURE__*/React.createElement(ProfileSectionPrimaryUserAddtlIconPadding, null, userInfoTypeMapper[userInfoType].icon) : userInfoTypeMapper[userInfoType].icon), /*#__PURE__*/React.createElement(ProfileSectionPrimaryUserInfoText, null, userInfo))) : null;
};